import { FREQUENCY } from '@funnels/constants';
import { convert, formatToPrecision } from '@funnels/utils';

/**
 * Calculate the loan term
 *
 * @param balance: The balance remaining
 * @param interest rate: The rate of interest for the loan term
 * @param repayment: the repayment to be made
 * @param extraContribution: extra contribution to repayment. This is set to the same frequency as the repayment frequency.
 * @param repaymentFrequency: Default monthly. Repayment frequency. The amount returned corresponds to this frequency
 *
 * @return The loan term in years.
 */
export function calculateLoanTerm(
  balance?: number,
  interestRate?: number,
  repayment?: number,
  extraContribution: number = 0,
  repaymentFrequency?: FREQUENCY
) {
  if (!balance || !interestRate || !repayment || !repaymentFrequency) {
    return;
  }
  // prettier-ignore
  const interestRateMonthly = (interestRate / 12);
  const repaymentMonthly = convert(repayment, repaymentFrequency, FREQUENCY.MONTHLY);
  const extraContributionMonthly = convert(extraContribution, repaymentFrequency, FREQUENCY.MONTHLY);
  // prettier-ignore
  const numberOfRepayments = Math.min(-Math.log(Math.max(1 - (interestRateMonthly / 100 * balance) / (repaymentMonthly + extraContributionMonthly), 0)) / Math.log(1 + (interestRateMonthly / 100)), 100 * 12);

  if (isNaN(numberOfRepayments) || numberOfRepayments === Infinity) {
    return;
  }

  return formatToPrecision(numberOfRepayments / 12);
}
